import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { digitsOnly } from './validation.utils';

const controlDigitWeights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

export const norwegianBankAccountValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const raw = (control.value ?? '').toString().trim();

  if (!raw) {
    return null;
  }

  const digitsText = digitsOnly(raw);
  if (digitsText.length !== 11 || digitsText !== raw.replace(/[\s.]/g, '')) {
    return { norwegianBankAccount: true };
  }

  const digits = digitsText.split('').map(Number);
  const weightedSum = controlDigitWeights.reduce((sum, weight, index) => sum + weight * digits[index], 0);
  const remainder = 11 - (weightedSum % 11);
  const expectedControlDigit = remainder === 11 ? 0 : remainder;

  return digits[10] === expectedControlDigit ? null : { norwegianBankAccount: true };
};
